import React from "react";
import "./TotalExpensesButton.css";
import Link from "../Link";
import union from "../../img/union-black.svg"
import right4 from "../../img/right-4@2x.svg"


const TotalExpensesButton = (props) => {
  const { className, logo } = props;

  return (
    <div className="total-expenses-button">
      <div className="overlap-group5">
        <div className="total-income-button">
          <Link href="/expenses" className="overlap-group-65">
            <img className="union" src={`${logo || union}`} />
            <img className="right-6" src={right4}></img>
            <div className={`total-expenses-1 ${className || "nunito-bold-black-14px"}`}>Total Expenses</div>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default TotalExpensesButton;
